export var NEW_ON_EDEL = "NEW_ON_EDEL";
export var NEW_ON_EDEL_ERROR = "NEW_ON_EDEL_ERROR";
export var NEW_ON_EDEL_HIDE_ERROR = "NEW_ON_EDEL_HIDE_ERROR";
export var NEW_ON_EDEL_START_LOADER = "NEW_ON_EDEL_START_LOADER";
export var NEW_ON_EDEL_STOP_LOADER = "NEW_ON_EDEL_STOP_LOADER";
